import type { StyleRule } from '@archipro-design/aria';
import { captionClassName, pxToRem } from '@archipro-design/aria';

// Class name formerly exported by Aria NavigationList.
const navigationListClassName = 'ui-navigationList';
import { paginationItemEllipsisClassName } from '@archipro-design/aria';
import { paginationItemContentClassName } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const ProjectCategoryContainer: StyleRule = ({ theme }) => ({
    [`& .${paginationItemContentClassName}__page`]: {
        '&[aria-current="true"]': {
            backgroundColor:
                theme.siteVariables.colorScheme.default!.foreground,
        },
        '&:not(:disabled):not([aria-current])': {
            color: theme.siteVariables.colorScheme.default!.foreground,
        },
    },
    [`& .${paginationItemEllipsisClassName}`]: {
        [`& .${svgIconClassName} svg`]: {
            fill: theme.siteVariables.colorScheme.default!.foreground,
        },
    },
    [`& .${paginationItemContentClassName}__prevNext:not(:disabled)`]: {
        color: theme.siteVariables.colorScheme.default!.foreground,
        ['& .' + svgIconClassName]: {
            '& svg ': {
                fill: theme.siteVariables.colorScheme.default!.foreground,
            },
        },
    },
    ['& .' + navigationListClassName]: {
        ['& .' + captionClassName]: {
            color: theme.siteVariables.colorScheme.default!.foreground,
        },
    },
});

export const APConnectBannerCell: StyleRule = ({ theme }) => ({
    width: '100%',
    margin: 0,
    [theme.screen.laptop]: {
        width: 'inherit',
        marginLeft: pxToRem(10),
        marginRight: pxToRem(10),
        gridColumnStart: 1,
        gridColumnEnd: 4,
    },
});
